export const rests = {
  auth: {
    login: '/rest/admin/org/login/signin',
    refresh_token: '/rest/admin/org/login/refresh-token',
    permissions: '/rest/admin/org/auth/permissions',
    request_sms_code: (phone) => `/rest/cabinet/org/auth/action/confirmcode/${phone}`,
    send_code: '/rest/cabinet/org/auth/action/password',
    difficulty_level: '/rest/admin/glob/passwords/get-password-strength-level',
  },
  profile: {
    get: '/rest/admin/org/profile/get',
    edit: '/rest/admin/org/profile/edit',
    change_password: '/rest/admin/org/profile/changePassword',
    send_code: (type) => `/rest/admin/org/sms/send-code?confirmType=${type}`,
    regulations_accept: (code) => `/rest/admin/org/profile/regulations-accept?smsCode=${code}`,
  },
  company: {
    list: '/rest/admin/org/shop-company/list',
    create: '/rest/admin/org/shop-company/create',
    edit: (id) => `/rest/admin/org/shop-company/edit/${id}`,
    get_by_id: (id) => `/rest/admin/org/shop-company/get/${id}`,
    activate: (companyId) => `/rest/admin/billing/company-tariffs/${companyId}/activate`,
    block: (companyId) => `/rest/admin/billing/company-tariffs/${companyId}/block`,
    umag_currency_root: (currency) => `/rest/admin/org/office-company/umag-root-company/get?countryCode=${currency}`,
    massive_transfer: '/rest/admin/billing/parent-franchise/set-for-companies',
    list_by_tariff_plan: '/rest/admin/org/partner-company/list-by-tariff-plan',
    set_franchise: '/rest/admin/billing/parent-franchise/set-for-franchise',
    set_company: '/rest/admin/billing/parent-franchise/set-for-company',
    get_currency: '/rest/admin/billing/currency-access/get-current-allowed-currencies',
    get_logo: '/rest/admin/images/company-logo/get',
    save_logo: () => '/rest/admin/images/company-logo/save',
    self_unlocking: (companyId) => `/rest/admin/org/companies/${companyId}/self-unlocking`,
    office: {
      list: '/rest/admin/org/office-company/list',
      create: '/rest/admin/org/office-company/create',
      get_by_id: (id) => `/rest/admin/org/office-company/get/${id}`,
      edit: (id) => `/rest/admin/org/office-company/edit/${id}`,
      block: (id) => `/rest/admin/org/office-company/block/${id}`,
      unblock: (id) => `/rest/admin/org/office-company/unblock/${id}`,
    },
    share: {
      create: '/rest/admin/billing/franchise-royalty/save',
      list: '/rest/admin/billing/franchise-royalty/list',
    },
  },
  application: {
    file_readme_create: () => '/rest/admin/glob/app_release/create',
    file_common_upload: (id) => `/rest/admin/glob/app_release/add-file/${id}`,
    file_release_upload: (id) => `/rest/admin/glob/app_release/add-release-file/${id}`,
    file_updater_upload: (id) => `/rest/admin/glob/app_release/add-update-file/${id}`,
    minor_version_groups: '/rest/admin/pos/app-release/minor-version-groups',
    list: '/rest/admin/glob/app_release/list',
    get_by_id: (id) => `/rest/admin/glob/app_release/get/${id}`,
    get_android: (version) => `/rest/admin/glob/app_release/stores-with-poses/app-version/${version}`,
    start_end_of_life: (id) => `/rest/admin/glob/app_release/edit-support-end-date/${id}`,
    cancel_eol: (id) => `/rest/admin/glob/app_release/cancel-unsupported/${id}`,
    coverage_update: (id: any) => `/rest/admin/glob/app_release/edit/${id}`,
    file_download: (id) => `/rest/admin/glob/app_release/download-file/${id}`,
    set_release_date: (id) => `/rest/admin/glob/app_release/set-release-date/${id}`,
    file_remove: '/rest/admin/glob/app_release/remove-file',
    note: {
      create: '/rest/admin/glob/app-release-note/create',
      edit: '/rest/admin/glob/app-release-note/edit',
      delete: (id) => `/rest/admin/glob/app-release-note/delete/${id}`,
    },
    comment: (id) => `/rest/admin/glob/app_release/note/${id}`,
    get_android_pos: '/rest/admin/glob/app_release/android/list',
  },
  bugs_report: {
    list: '/rest/admin/glob/bug-report/list',
    merge: '/rest/admin/glob/bug-report/merge',
    get_by_id: (id) => `/rest/admin/glob/bug-report/get/${id}`,
    change_status: (id) => `/rest/admin/glob/bug-report/edit-status/${id}`,
  },
  billing: {
    accounts_get: '/rest/admin/billing/accounts/list',
    payment_create: '/rest/admin/billing/payments/create',
    payments_list: '/rest/admin/billing/payments/list',
    subscription_charges: '/rest/admin/billing/subscription-charges/list',
    subscription_charge_reports: '/rest/admin/billing/subscription-charge-reports/list',
    tariff_change_reports: '/rest/admin/billing/company-tariff-change-reports/list',
    get_price_list_tariff_plan: '/rest/admin/billing/company-tariffs/tariff-by-company',
    get_pos_list: '/rest/admin/org/pos/list-active',
    tariff_plan_monthly_bill_get: '/rest/admin/billing/company-tariffs/period-bill',
    tariff_plan_calc_to_pay: '/rest/admin/billing/company-tariffs/calc-bill-to-pay',
    fisc_agent_price: '/rest/admin/billing/subscription/plan/option/monthly-price',
    tariff_get: (companyId) => `/rest/admin/billing/company-tariffs/get/${companyId}`,
    payment_remove: '/rest/admin/billing/payments/create-refund',
    cloud_payment_id: '/rest/admin/glob/credentials/get-payment-pid',
    create_invoice: '/rest/admin/fin/invoice/create',
    get_income_share: '/rest/admin/billing/franchise-royalty/get-all-actual',
    card_info: (companyId: number) => `/rest/admin/billing/tiptop-pay/card/availability?companyId=${companyId}`,
    get_balance: (id) => `/rest/admin/billing/franchises/get-balance/${id}`,
    aggregated_balance_report: '/rest/admin/billing/reports/balance-companies',
    company_reports: '/rest/admin/adm/reports/companies',
    payment_history: {
      list: '/rest/admin/billing/payments/list-all',
      subscription_profit: (id) => `/rest/admin/billing/franchises/subscription-charge-profit/${id}`,
      own_debit: (id) => `/rest/admin/billing/franchises/${id}/debt`,
      client_debit: (id) => `/rest/admin/billing/companies/${id}/debt`,
    },
    tariff: {
      list: '/rest/admin/billing/tariffs/list',
      actual_tariffs: (currency) => `/rest/admin/billing/tariffs/actual-tariffs?currency=${currency}`,
      currencies: '/rest/admin/billing/tariffs/currencies',
      create: '/rest/admin/billing/tariffs/create',
      delete: (tariffId) => `/rest/admin/billing/tariffs/delete/${tariffId}`,
      edit: '/rest/admin/billing/company-tariffs/edit',
      config: '/rest/admin/billing/company-tariffs/config',
      cancel_tariff_edit: '/rest/admin/billing/company-tariffs/cancel-deferred',
    },
  },
  store: {
    create: '/rest/admin/org/store/create',
    list: '/rest/admin/org/store/list',
    list_by_uptime: '/rest/admin/org/store/list-by-uptime',
    uptime_update: (id) => `/rest/admin/org/store/update-uptime/${id}`,
    edit_store_name: (id) => `/rest/admin/org/store/edit/${id}`,
    edit_store_detail: (id) => `/rest/admin/org/store/edit-detail/${id}`,
    store_get_by_id: (id) => `/rest/admin/org/store/get/${id}`,
    edit_store_config: (id) => `/rest/admin/org/store/edit-config/${id}`,
    delete_store: (id) => `/rest/admin/org/store/delete/${id}`,
    restore_store: (id) => `/rest/admin/org/store/restore/${id}`,
    edit_markup: (storeId) => `/rest/admin/org/store/edit-markup/${storeId}`,
    clear: (id) => `/rest/admin/org/store/clear/${id}`,
    activity_list: '/rest/admin/adm/store-activity/list',
    statistics_by_franchise: '/rest/admin/adm/store-activity/list-by-franchisee',
    statistics_by_store: '/rest/admin/adm/store-activity/list-by-store-type',
    get_store_pos_count: '/rest/admin/opr/fisc/poses/count-integrations',
    types: '/rest/partner/org/stores/types',
  },
  product: {
    list: '/rest/admin/nom/global-product/list',
    create: '/rest/admin/nom/global-product/create',
    approve: (id) => `/rest/admin/nom/global-product/approve/${id}`,
    edit: (id) => `/rest/admin/nom/global-product/edit/${id}`,
    delete: (id) => `/rest/admin/nom/global-product/delete/${id}`,
    upload_product: '/rest/admin/nom/product/upload-products',
    category: {
      list: '/rest/admin/nom/global-category/list',
    },
    sub_category: {
      list: '/rest/admin/nom/global-category/list-sub',
    },
  },
  pos: {
    list: '/rest/admin/org/pos/list',
    get_by_id: (id) => `/rest/admin/org/pos/get/${id}`,
    edit: (id) => `/rest/admin/org/pos/edit/${id}`,
    delete: (id) => `/rest/admin/org/pos/delete/${id}`,
    restore: (id) => `/rest/admin/org/pos/restore/${id}`,
    create: '/rest/admin/org/pos/create',
    edit_config: (id) => `/rest/admin/org/pos/edit-config/${id}`,
  },
  support: {
    support_access: (id) => `/rest/admin/org/support-access/request/${id}`,
  },
  store_group: {
    list: '/rest/admin/org/store-group/list',
    create: '/rest/admin/org/store-group/create',
    check_partner_group_price: '/rest/admin/nom/product/is-product-infos-similar',
    set_partner_group_price: '/rest/admin/nom/product/set-similar-product-infos',
    check_partner_group_code: '/rest/admin/nom/product-alias/is-aliases-similar',
    set_partner_group_code: '/rest/admin/nom/product-alias/set-similar-aliases',
    get_by_id: (id) => `/rest/admin/org/store-group/get/${id}`,
    edit: (id) => `/rest/admin/org/store-group/edit/${id}`,
    config_edit: (id) => `/rest/admin/org/store-group/edit-config/${id}`,
    delete: (id) => `/rest/admin/org/store-group/delete/${id}`,
    hide: (id) => `/rest/admin/org/store-group/hide/${id}`,
    unblock: (id) => `/rest/admin/org/store-group/show/${id}`,
  },
  notification: {
    list: '/rest/admin/notif/motd/list',
    create: '/rest/admin/notif/motd/create',
    edit: '/rest/admin/notif/motd/edit',
    publish: (id) => `/rest/admin/notif/motd/publish/${id}`,
  },
  push_notification: {
    create: '/rest/admin/notif/push-notification/create',
    list: '/rest/admin/notif/push-notification/list',
  },
  sms_mailing: {
    send_by_sms_mailing: '/rest/admin/glob/sms/send-by-phone',
  },
  user: {
    admin: {
      list: '/rest/admin/org/shop-user/list',
      user_group_list_permission: '/rest/admin/org/shop-user-group/list-permissions',
      user_group_create: '/rest/admin/org/shop-user-group/create',
      user_group_update: (userGroupId) => `/rest/admin/org/shop-user-group/edit/${userGroupId}`,
      user_group_delete: (userGroupId) => `/rest/admin/org/shop-user-group/delete/${userGroupId}`,
      get_user_group: (id) => `/rest/admin/org/shop-user-group/get/${id}`,
      update_owner: (companyId) => `/rest/admin/org/partner-company/edit-owner/${companyId}`,
    },
    umag: {
      user_groups_lists: '/rest/admin/org/office-user-group',
      list: '/rest/admin/org/office-user/list',
      user_group_list: '/rest/admin/org/office-user-group/list',
      create: '/rest/admin/org/office-user/create',
      get_user: (userId) => `/rest/admin/org/office-user/get/${userId}`,
      edit_user: (userId) => `/rest/admin/org/office-user/edit/${userId}`,
      delete_user: (userId) => `/rest/admin/org/office-user/delete/${userId}`,
      restore_user: (userId) => `/rest/admin/org/office-user/restore/${userId}`,
    },
    list_with_stores: '/rest/admin/org/partner-user/list-with-stores',
    active_partners: (companyId) => `/rest/admin/org/partner-user/list-active?companyId=${companyId}`,
    managers: '/rest/admin/org/office-user/sales-managers',
    supports: '/rest/admin/org/office-user/supports',
  },
  geo: {
    unit_list: '/rest/admin/glob/geo-unit/list',
    list_copy: '/rest/admin/glob/geo-unit/list-settlements-by-country',
  },
  settings: {
    user_group: {
      list: '/rest/admin/org/office-user-group/list',
      create: '/rest/admin/org/office-user-group',
      get_by_id: (userId) => `/rest/admin/org/office-user-group/get/${userId}`,
      edit: (userId) => `/rest/admin/org/office-user-group/${userId}`,
      delete: (userId) => `/rest/admin/org/office-user-group/${userId}`,
    },
  },
  master_franchise: {
    create: '/rest/admin/org/office-company/master',
    get_offices: (id) => `/rest/admin/org/office-company/list-franchise-by-master/${id}`,
  },
  grading: {
    endpoint: '/rest/admin/org/user-grade/sales-manager/grading',
    information_about_managers: '/rest/admin/org/user-grade/sales-manager/user-grades',
    delete: (id) => `/rest/admin/org/user-grade/sales-manager/grading/${id}`,
  },
  assign_sales_manager: {
    endpoint: (storeId, managerId) => `/rest/admin/org/store/${storeId}/sales-manager/${managerId}`,
  },
  fiscalization: {
    get_users_list: (companyId) => `/rest/admin/opr/fisc/users/get?companyId=${companyId}`,
    create_user: '/rest/admin/opr/fisc/users/create',
    edit_user: (agentUserId) => `/rest/admin/opr/fisc/users/edit/${agentUserId}`,
    delete_user: (agentUserId) => `/rest/admin/opr/fisc/users/delete/${agentUserId}`,
    get_cash: (companyId) => `/rest/admin/opr/fisc/poses/get?companyId=${companyId}`,
    create_cash: () => '/rest/admin/opr/fisc/poses/create',
    delete_cash: (posId) => `/rest/admin/opr/fisc/poses/delete/${posId}`,
    edit_cash: (posId) => `/rest/admin/opr/fisc/poses/edit/${posId}`,
    get_pos_data: (posId) => `/rest/admin/opr/fisc/poses/get?posId=${posId}`,
    get_agent_users: '/rest/admin/opr/fisc/users/get',
    get_report: '/rest/admin/opr/fisc/report/get',
    reset: '/rest/admin/opr/fisc/report/reset-attempts',
    get_report_statistics: '/rest/admin/opr/fisc/report/statistics',
    get_agent_types: '/rest/admin/opr/fisc/users/get-agent-types',
  },
  poll: {
    get: '/rest/admin/org/polls/get',
    save: () => '/rest/admin/org/polls/save',
  },
  features: {
    save_feature_version: '/rest/admin/org/users/enabled-feature/current/save',
    delete_feature_version: '/rest/admin/org/users/enabled-feature/current/delete',
    get_feature_version: '/rest/admin/org/users/enabled-feature/current/list',
  },
};
